import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { ServiceType } from '../Types/ServiceType'
import { ServiceDto } from '../Types/ServiceDto'

export default class ClvrService {
    public id: Nullable<number> = null
    public groupId: Nullable<number> = null
    public name = ''

    public constructor(data?: ServiceType) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public toDto(): ServiceDto {
        return {
            id: this.id,
            group_id: this.groupId,
            nom: this.name,
        }
    }
}
